<div [formGroup]="this.form">
  <div
    class="knowledge-test-page"
    *ngIf="page === 1"
  >
    <div class="columns column1">
      <div
        appConfigSettingsParagraph
        class="sub-title"
        [innerHTML]="'KnowledgeTest.P1' | translate">
      </div>
      <br>
      <div appConfigSettingsParagraph>
        {{'KnowledgeTest.P2' | translate}}
      </div>
      <div>
        <app-toggle-input
          autofocus
          [placeholder]="this.questions[0].translationTitle"
          [placeholderPrefix]="this.questions[0].order + '/' + questionsAmount + '.'"
          [form]="form"
          [optionsList]="yesNoList"
          [control]="form.get(this.questions[0].name)"
          appConfigSettingsParagraph
          required
          isRequiredMessageKey="Calculation.RequiredField"
          [groupBy2InLine]="true"
          [disabled]="knowledgeTestFormService.isTestCompleted"
        ></app-toggle-input>
        <app-toggle-input
          [placeholder]="this.questions[1].translationTitle"
          [placeholderPrefix]="this.questions[1].order + '/' + questionsAmount + '.'"
          [form]="form"
          [optionsList]="yesNoList"
          [control]="form.get(this.questions[1].name)"
          appConfigSettingsParagraph
          required
          isRequiredMessageKey="Calculation.RequiredField"
          [groupBy2InLine]="true"
          [disabled]="knowledgeTestFormService.isTestCompleted"
        ></app-toggle-input>
        <app-knowledge-test-select
          [placeholder]="this.questions[2].translationTitle"
          [placeholderPrefix]="this.questions[2].order + '/' + questionsAmount + '.'"
          [selectOptions]="this.questions[2].options"
          [formControlName]="this.questions[2].name"
          [control]="form.get(this.questions[2].name)"
          appConfigSettingsParagraph
          required
          isRequiredMessageKey="Calculation.RequiredField"
          [disabled]="knowledgeTestFormService.isTestCompleted"
        ></app-knowledge-test-select>
      </div>
    </div>
    <div class="columns column2">
      <app-knowledge-test-select
        [placeholder]="this.questions[3].translationTitle"
        [placeholderPrefix]="this.questions[3].order + '/' + questionsAmount + '.'"
        [selectOptions]="this.questions[3].options"
        [formControlName]="this.questions[3].name"
        [control]="form.get(this.questions[3].name)"
        appConfigSettingsParagraph
        required
        isRequiredMessageKey="Calculation.RequiredField"
        [disabled]="knowledgeTestFormService.isTestCompleted"
      ></app-knowledge-test-select>
      <app-knowledge-test-select
        [placeholder]="this.questions[4].translationTitle"
        [placeholderPrefix]="this.questions[4].order + '/' + questionsAmount + '.'"
        [selectOptions]="this.questions[4].options"
        [formControlName]="this.questions[4].name"
        [control]="form.get(this.questions[4].name)"
        appConfigSettingsParagraph
        required
        isRequiredMessageKey="Calculation.RequiredField"
        [disabled]="knowledgeTestFormService.isTestCompleted"
      ></app-knowledge-test-select>
    </div>
  </div>
  <div
    class="knowledge-test-page"
    *ngIf="page === 2"
  >
    <div class="columns column1">
      <div>
        <app-knowledge-test-select
          [placeholder]="this.questions[5].translationTitle"
          [placeholderPrefix]="this.questions[5].order + '/' + questionsAmount + '.'"
          [selectOptions]="this.questions[5].options"
          [formControlName]="this.questions[5].name"
          [control]="form.get(this.questions[5].name)"
          appConfigSettingsParagraph
          required
          isRequiredMessageKey="Calculation.RequiredField"
          [disabled]="knowledgeTestFormService.isTestCompleted"
        ></app-knowledge-test-select>
        <app-knowledge-test-select
          [placeholder]="this.questions[6].translationTitle"
          [placeholderPrefix]="this.questions[6].order + '/' + questionsAmount + '.'"
          [selectOptions]="this.questions[6].options"
          [formControlName]="this.questions[6].name"
          [control]="form.get(this.questions[6].name)"
          appConfigSettingsParagraph
          required
          isRequiredMessageKey="Calculation.RequiredField"
          [disabled]="knowledgeTestFormService.isTestCompleted"
        ></app-knowledge-test-select>
      </div>
    </div>
    <div class="columns column2">
      <app-knowledge-test-select
        [placeholder]="this.questions[7].translationTitle"
        [placeholderPrefix]="this.questions[7].order + '/' + questionsAmount + '.'"
        [selectOptions]="this.questions[7].options"
        [formControlName]="this.questions[7].name"
        [control]="form.get(this.questions[7].name)"
        appConfigSettingsParagraph
        required
        isRequiredMessageKey="Calculation.RequiredField"
        [disabled]="knowledgeTestFormService.isTestCompleted"
      ></app-knowledge-test-select>
      <app-knowledge-test-select
        [placeholder]="this.questions[8].translationTitle"
        [placeholderPrefix]="this.questions[8].order + '/' + questionsAmount + '.'"
        [selectOptions]="this.questions[8].options"
        [formControlName]="this.questions[8].name"
        [control]="form.get(this.questions[8].name)"
        appConfigSettingsParagraph
        required
        isRequiredMessageKey="Calculation.RequiredField"
        [disabled]="knowledgeTestFormService.isTestCompleted"
      ></app-knowledge-test-select>
    </div>
  </div>
  <div
    class="knowledge-test-page"
    *ngIf="page === 3"
  >
    <div class="columns column1">
      <div>
        <app-knowledge-test-select
          [placeholder]="this.questions[9].translationTitle"
          [placeholderPrefix]="this.questions[9].order + '/' + questionsAmount + '.'"
          [selectOptions]="this.questions[9].options"
          [formControlName]="this.questions[9].name"
          [control]="form.get(this.questions[9].name)"
          appConfigSettingsParagraph
          required
          isRequiredMessageKey="Calculation.RequiredField"
          [disabled]="knowledgeTestFormService.isTestCompleted"
        ></app-knowledge-test-select>
        <app-knowledge-test-select
          [placeholder]="this.questions[10].translationTitle"
          [placeholderPrefix]="this.questions[10].order + '/' + questionsAmount + '.'"
          [selectOptions]="this.questions[10].options"
          [formControlName]="this.questions[10].name"
          [control]="form.get(this.questions[10].name)"
          appConfigSettingsParagraph
          required
          isRequiredMessageKey="Calculation.RequiredField"
          [disabled]="knowledgeTestFormService.isTestCompleted"
        ></app-knowledge-test-select>
      </div>
    </div>
    <div class="columns column2">
      <app-knowledge-test-select
        [placeholder]="this.questions[11].translationTitle"
        [placeholderPrefix]="this.questions[11].order + '/' + questionsAmount + '.'"
        [selectOptions]="this.questions[11].options"
        [formControlName]="this.questions[11].name"
        [control]="form.get(this.questions[11].name)"
        appConfigSettingsParagraph
        required
        isRequiredMessageKey="Calculation.RequiredField"
        [disabled]="knowledgeTestFormService.isTestCompleted"
      ></app-knowledge-test-select>
      <div class="buttons-control-container">
        <button
          type="button"
          appConfigSettingsPrimaryButton
          class="save-btn primary knowledge-test-finish-btn"
          color="primary"
          [disabled]="knowledgeTestFormService.isTestCompleted"
          [ngClass]="{'disabled': knowledgeTestFormService.isTestCompleted}"
          (click)="finishTest()"
        >
          {{ "KnowledgeTest.finishTest" | translate }}
        </button>
      </div>
      <div
        appConfigSettingsBackground
        *ngIf="knowledgeTestFormService.isTestCompleted" class="knowledge-test-result"
      >
        <div class="knowledge-test-result-message">
          <div class="knowledge-test-result-message-title">
            {{ knowledgeTestFormService.isTestPassed ? ("KnowledgeTest.successMessageTitle" | translate) : "KnowledgeTest.failMessageTitle" | translate }}
          </div>
          <div *ngIf="knowledgeTestFormService.isTestPassed">
            {{"KnowledgeTest.successMessage" | translate}}
          </div>
          <div *ngIf="!knowledgeTestFormService.isTestPassed">
            <div class="knowledge-test-result-message-failed">{{"KnowledgeTest.failMessage1" | translate}}</div>
            <div class="knowledge-test-result-message-failed">{{"KnowledgeTest.failMessage2" | translate}}</div>
            <div class="knowledge-test-result-message-failed">{{"KnowledgeTest.failMessage3" | translate}}</div>
          </div>
        </div>
      </div>
      <div
        class="offer-form-container"
        *ngIf="knowledgeTestFormService.isTestCompleted && !knowledgeTestFormService.isTestPassed"
      >
        <app-knowledge-test-email-offer-form></app-knowledge-test-email-offer-form>
      </div>
    </div>
  </div>
</div>
